import React, { useState, Fragment } from 'react'
import { useShared } from '../../hooks/useShared'
import AMenu from '../../components/partials/AMenu';
import MainSection from '../../components/sections/MainSection';
import AIcon from '../../components/partials/AIcon';
import LogsDataModal from '../../components/modals/LogsDataModal';
import { Card } from '@material-tailwind/react';
//import NewRole from './NewRole';

const TABLE_HEAD = ["No.", "File", "Size",'Date', 'Actions'];
const breadcrumbs = [{ name: 'باکپس', link: '/backups' }]
const menuData = [
  { flag: "Delete", name: 'حذف', icon: 'trash-outline', roles: [1] },
]
const searchInputFields = [
  { label: 'Model', name: 'model', type: 'text', roles: [1], icon: 'text-outline', className: 'md:col-span-3' },
  { label: 'Log Type', name: 'action', type: 'text', roles: [1], icon: 'text-outline', className: 'md:col-span-3', options: [] },
  { label: 'IP', name: 'ip', type: 'text', roles: [1], icon: 'text-outline', className: 'md:col-span-3', },
  { label: 'Creator', name: 'creator', type: 'text', roles: [1], icon: 'text-outline', className: 'md:col-span-3', },

];



export default function Backups() {


  const { com, setModel, models, setShowViewDialog, showDeleteDialog, setShowDeleteDialog } = useShared();

  const handleMenu = (model, flag = false) => {
    console.log("handleMenu ", model, flag);

    if (flag === 'delete') {
      setModel(model)
      setShowDeleteDialog(!showDeleteDialog)
    }
    if (flag === 'edit') {
      setModel(model)


    }
    if (flag === 'view') {
      setModel(model)
      setShowViewDialog(true)
    }
  };



  
  const getTableData = () => {

    return (<tbody className='' dir='ltr'>
      {models&&models?.backups?.map((r, i) => {
        return (
          <Fragment key={i}>
            {setTableData(r, i)}
          </Fragment>)
      })}
    </tbody>)
  }

  const setTableData = (r, i) => {

    return (
      <tr key={r.id} className={` !text-sm`} >
        <td >{1 + i} </td>
        <th className='text-left'> <span className={r?.file_name.includes("db")? "text-green-600":r?.file_name.includes("files")?'text-purple-800':'text-red-900'}>{r?.file_name}</span>  </th>
        <td>{com.formatBytes(r?.file_size)}</td>
        <td  >{r?.date}</td>

        <td >
          <AMenu v={{ handleMenu: (row, flag) => handleMenu(row, flag), row: r, menuData }} />

        </td></tr>)
  }


  return (
    <>
      <MainSection v={{
        searchInputFields,
        TABLE_HEAD,
        breadcrumbs,
        tableData: getTableData(),
        url: "backups",
        modelName: { name: 'logs', af: 'باکپس' },
        mUrl: { delete: 'backups', create: 'backups', getAll: 'getAll' },
        tableTitle: 'ليست باکپس',
        advanceSearch: 'backups',
        modelScreen: 'backups',
      }} />

      </>
      )
}
